import React from 'react';
import { useNavigate, useLocation, Link as RouterLink } from 'react-router-dom';
import {
  Box,
  Container,
  Card,
  CardContent,
  Typography,
  Button
} from '@mui/material';
import {
  MarkEmailRead as EmailIcon
} from '@mui/icons-material';

function VerifyEmailSplash() {
  const navigate = useNavigate();
  const location = useLocation();
  const email = location.state?.email || '';

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: 'background.default',
        py: 4
      }}
    >
      <Container maxWidth="sm">
        <Card elevation={3}>
          <CardContent sx={{ p: 4, textAlign: 'center' }}>
            <EmailIcon
              sx={{
                fontSize: 80,
                color: 'primary.main',
                mb: 2
              }}
            />

            <Typography
              variant="h4"
              component="h1"
              gutterBottom
              sx={{ fontWeight: 700, mb: 2 }}
            >
              Check Your Email
            </Typography>

            <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.8 }}>
              We've sent a verification email to:
            </Typography>

            {email && (
              <Typography
                variant="h6"
                sx={{
                  fontWeight: 600,
                  color: 'primary.main',
                  mb: 3,
                  wordBreak: 'break-word'
                }}
              >
                {email}
              </Typography>
            )}

            <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.8 }}>
              Please check your inbox and click the verification link to activate your account.
            </Typography>

            <Typography variant="body2" color="text.secondary" sx={{ mb: 4 }}>
              Don't see the email? Check your spam folder or contact support if you need help.
            </Typography>

            <Button
              component={RouterLink}
              to="/login"
              variant="contained"
              size="large"
              sx={{ px: 4 }}
            >
              Go to Login
            </Button>
          </CardContent>
        </Card>
      </Container>
    </Box>
  );
}

export default VerifyEmailSplash;
